import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssinaturaService } from '../../../core/services/assinatura.service';
import { Assinatura } from '../../../core/models/assinatura';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AuthService } from '../../../core/services/auth.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-assinatura-list',
  templateUrl: './assinatura-list.component.html',
  styleUrls: ['./assinatura-list.component.scss'],
})
export class AssinaturaListComponent implements OnInit {
  assinaturas: Assinatura[] = [];
  loading = false;
  private empresaId?: string | null;

  constructor(
    private service: AssinaturaService,
    private router: Router,
    private route: ActivatedRoute,
    private message: MessageService,
    private confirmation: ConfirmationService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const empresaId = this.authService.getEmpresaId();
    if (!empresaId) {
      this.message.add({ severity: 'warn', summary: 'Tenant ausente', detail: 'Empresa (tenant) não configurada. Faça login novamente.' });
      return;
    }

    this.empresaId = empresaId;
    this.loadByEmpresa(empresaId);
  }

  private loadByEmpresa(empresaId: string) {
    this.loading = true;
    this.service
      .getByEmpresa(empresaId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res: Assinatura) => (this.assinaturas = res ? [res] : []),
        error: (err: any) => this.message.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar assinaturas da empresa' }),
      });
  }

  view(a: Assinatura) {
    const target = a.empresaId || a.id;
    if (!target) return;
    this.router.navigate(['/assinaturas', target]);
  }

  edit(a: Assinatura) {
    const target = a.empresaId || a.id;
    if (!target) return;
    this.router.navigate(['/assinaturas', target, 'editar']);
  }

  confirmarCancelar(a: Assinatura) {
    const target = a.empresaId || a.id;
    if (!target) return;
    this.confirmation.confirm({
      message: `Confirma cancelar assinatura #${target}?`,
      accept: () => {
        this.service.cancelar(String(target)).subscribe({
          next: (ret: Assinatura) => {
            this.message.add({ severity: 'success', summary: 'Sucesso', detail: 'Assinatura cancelada' });
            if (this.empresaId) this.loadByEmpresa(this.empresaId);
          },
          error: (err: any) => this.message.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao cancelar' }),
        });
      },
    });
  }

  renovar(a: Assinatura) {
    // simplificado: renovar com mesmo plano
    const target = a.empresaId || a.id;
    if (!target) return;
    this.confirmation.confirm({
      message: `Confirma renovar assinatura #${target}?`,
      accept: () => {
        this.service.renovar(String(target), { plano: a.planoAssinatura }).subscribe({
          next: () => {
            this.message.add({ severity: 'success', summary: 'Sucesso', detail: 'Assinatura renovada' });
            if (this.empresaId) this.loadByEmpresa(this.empresaId);
          },
          error: () => this.message.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao renovar' }),
        });
      },
    });
  }

  create() {
    this.router.navigate(['/assinaturas', 'cadastrar']);
  }
}
